// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root___9UD-","selected":"Chip_selected__3UMpO"};